(() => {
  if (window.__nextylTileVariantResolverLoaded) return;
  window.__nextylTileVariantResolverLoaded = true;

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects[data-nextyl-quote-product="true"]');
    if (!picker) return;
    event.stopImmediatePropagation();

    const groups = Array.from(picker.querySelectorAll(':scope > .product-form__input')).filter(
      (group) => group.querySelector('input[type="radio"], select')
    );
    const selected = groups.map((group) => group.querySelector('input:checked, select')?.value || null);
    const changedIndex = groups.indexOf(event.target.closest('.product-form__input'));
    const variantsNode = picker.querySelector('[data-nextyl-product-variants]');
    if (changedIndex < 0 || !variantsNode) return;

    let variants;
    try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }

    const exact = variants.find((variant) =>
      variant.options.length === selected.length &&
      variant.options.every((value, index) => value === selected[index])
    );
    const candidates = variants.filter((variant) => variant.options[changedIndex] === event.target.value);
    const resolved = exact || candidates
      .map((variant, order) => ({
        variant,
        order,
        score: variant.options.reduce(
          (score, value, index) => score + (index !== changedIndex && value === selected[index] ? 1 : 0),
          0
        )
      }))
      .sort((a, b) => b.score - a.score || a.order - b.order)[0]?.variant;
    if (!resolved) return;

    groups.forEach((group, index) => {
      const value = resolved.options[index];
      const select = group.querySelector('select');
      if (select) {
        select.value = value;
        Array.from(select.options).forEach((option) => option.toggleAttribute('selected', option.value === value));
      } else {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === value;
        });
      }
      const label = group.querySelector('[data-selected-value], [data-selected-swatch-value]');
      if (label) label.textContent = value;
    });

    const selectedVariantNode = picker.querySelector('[data-selected-variant]');
    if (selectedVariantNode) selectedVariantNode.textContent = JSON.stringify(resolved);

    const productInfo = picker.closest('product-info');
    if (productInfo) {
      productInfo.currentVariant = resolved;

      const skuValue = productInfo.querySelector('[id^="Sku-"] span:last-child');
      if (skuValue) skuValue.textContent = resolved.sku || '';

      if (typeof productInfo.updateURL === 'function') {
        productInfo.updateURL(productInfo.dataset.url, resolved.id);
      } else if (picker.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', picker.dataset.url + '?variant=' + resolved.id);
      }

      if (typeof productInfo.updateShareUrl === 'function') productInfo.updateShareUrl(resolved.id);
      if (typeof productInfo.updateVariantInputs === 'function') productInfo.updateVariantInputs(resolved.id);
      if (typeof productInfo.updateMedia === 'function') productInfo.updateMedia(resolved);
    }

    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: resolved } }));
  }, true);

  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    const picker = document.querySelector('variant-selects[data-nextyl-quote-product="true"]');
    const productInfo = picker?.closest('product-info');
    const skuValue = productInfo?.querySelector('[id^="Sku-"] span:last-child');
    if (skuValue) skuValue.textContent = variant.sku || '';
  });
})();
